import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    searchResults: [],
    isLoading: false,
    error: null,
};

const searchSlice = createSlice({
    name: 'search',
    initialState,
    reducers: {
        searchRequest: (state) => {
            state.isLoading = true;
            state.error = null;
        },
        setSearchResults: (state, action) => {
            console.log('action.payload', action.payload);
            state.searchResults = action.payload;
        },
    },
});


export const { searchRequest, setSearchResults } = searchSlice.actions;

export default searchSlice.reducer;